import {
  ARBITRARY_CELL,
  COUNTY_LEVEL_LAYER,
  H3_RES5_LEVEL_LAYER,
  H3_RES7_LEVEL_LAYER,
  STATE_LEVEL_LAYER,
} from './layer-store.service';

/**
 * What each level is called: `name` for a tile that carries none of its own,
 * `kind` for naming the selected cell when the two sides of the comparison are
 * different kinds of area, and for the popup's subheader. Deliberately not geocoded - this runs on every cell
 * the cursor crosses, and a request per cell would be both slow and, at h3
 * resolution, largely wasted.
 */
export const LEVEL_LABELS: { [level: string]: { name: string; kind: string } } =
  {
    [STATE_LEVEL_LAYER]: { name: 'This state', kind: 'state' },
    [COUNTY_LEVEL_LAYER]: { name: 'This county', kind: 'county' },
    [H3_RES5_LEVEL_LAYER]: { name: 'Cell (5 mile)', kind: '5-mile cell' },
    [H3_RES7_LEVEL_LAYER]: { name: 'Cell (1 mile)', kind: '1-mile cell' },
    [ARBITRARY_CELL]: { name: 'Trade area', kind: 'trade area' },
  };
